import { render, staticRenderFns } from "./languageSelect.vue?vue&type=template&id=38431dca&scoped=true&"
import script from "./languageSelect.vue?vue&type=script&lang=js&"
export * from "./languageSelect.vue?vue&type=script&lang=js&"
import style0 from "./languageSelect.vue?vue&type=style&index=0&id=38431dca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38431dca",
  null
  
)

export default component.exports